import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { AuthenticationService } from './../services/authentication.service';
import { AccountService } from './../services/account.service';
import { PrivacypolicyService } from './../services/privacypolicy.service';
import { PaymentService } from '../../payment-gateway/services/payment.service';
import { SessionManager } from '../../common/helpers/session-manager';
import { AppLoggingService } from '../../common/services/AppLogging.service';
//import { environment } from '../../../environments/environment.prod';
import { country } from '../../common/helpers/string-helper';

import { Member } from './../../common/models/member';
import { User } from './../../common/models/user';
import { PaymentHistoryLog } from './../../common/models/PaymentHistoryLog';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers: [AccountService]
})

export class RegisterComponent implements OnInit {

  // local members
  member: Member;
  paymentLog = new PaymentHistoryLog();
  isSubmitting: Boolean;
  errorMessage: String;
  islocalMemberAvailable: Boolean;
  varEmailValidate: boolean;
  errorForPaidUser: string;
  isV10PurchesedCustomer: boolean;
  progress: boolean | number = false;
  isCountryReadOnly: Boolean;
  user: User;
  orderLabelMessage: string;
  suggestionList: any[];
  privacyPolicyStatus: number;
  visible: Boolean;
  customerObj: any;
  isCustomerExistsAndPrivacyPolicyAccepted: Boolean;

  public hello = "Hello";

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private accountService: AccountService,
    private privacypolicyService: PrivacypolicyService,
    private paymentService: PaymentService,
    private sessionManager: SessionManager,
    private log: AppLoggingService,
    private activatedRoute: ActivatedRoute
  ) {
    this.member = new Member();
    this.errorMessage = '';
    this.errorForPaidUser = '';
    this.isSubmitting = false;
    this.islocalMemberAvailable = false;
    this.varEmailValidate = false;
    this.orderLabelMessage = '';
    this.suggestionList = [];
    this.visible = true;



  }

  ngOnInit() {

    debugger;
    this.authenticationService.getCurrentUser().subscribe((response: any) => {

      this.isV10PurchesedCustomer = false;
      if (response.emailAddress == null) {
        this.islocalMemberAvailable = false;
      } else {
        this.islocalMemberAvailable = true;
      }

      this.member = response;
      this.member.country = country.norway;
      this.sessionManager.generateSessionID();
      this.member.sessionId = localStorage.getItem('sessionID');
    });


    this.authenticationService.isLoggedIn().subscribe(loggedIn => {
      this.customerObj = <User>JSON.parse(localStorage.getItem('currentUser'));
    });
    this.privacyPolicyStatus = 0;
    this.isCountryReadOnly = true;

    if (this.customerObj != null) {
      this.privacypolicyService.getPrivacyPolicyDetails(this.customerObj.id).subscribe((privacyPolicyDetails) => {
        this.privacyPolicyStatus = privacyPolicyDetails.state;
      });
    }
  }

  validateEmail() {
    debugger;
    this.privacypolicyService.deactivatedCustomerEmail(this.member.emailAddress).subscribe((data) => {
      this.privacypolicyService.validateCustomerPrivacyPolicy(this.member.emailAddress).subscribe(data1 => {
        //customer exists and privacy policy accepted
        this.isCustomerExistsAndPrivacyPolicyAccepted = data1;
        if (this.isCustomerExistsAndPrivacyPolicyAccepted == true) {
          this.register();
        } else {
          this.visible = false;
          this.errorMessage = '';
        }
      });

    }, error => {

      console.log(error);
      debugger;
      if (error._body === '"WSSS556"') {
        this.router.navigate(['cannotregister']);
      }
      else {
        this.visible = false;
        this.errorMessage = '';
      }
      //debugger;
      // if (registrationFailed._body === '"WSSS556"') {
      //   this.router.navigate(['cannotregister']);
      // }
      // else {

      // }
    });
  }

  register() {


    //   this.router.navigate(['cannotregister']);  deactivatedCustomerEmail


    debugger;
    this.isSubmitting = true;
    this.errorMessage = 'Bekrefter';
    const status = false;
    this.progress = 0;

    const shoppingCart = this.sessionManager.getShoppingCartData();
    const promoCode = this.sessionManager.getPromoCode();

    this.paymentLog.orderId = shoppingCart.orderId;
    this.paymentLog.promoCode = promoCode;
    this.member.paymentHistoryLog = this.paymentLog;
    // this.privacyPolicyStatus = 0;
    // this.visible = true;


    //------------
    //if (this.privacyPolicyStatus == 1) {
    this.accountService.register(this.member)
      .subscribe(registrationSuccess => {
        // registrationSuccess._body = this.member;

        registrationSuccess = registrationSuccess.json();

        // tslint:disable-next-line:prefer-const
        let memberObject = new Member();

        memberObject.firstName = registrationSuccess.firstName;
        memberObject.middleName = registrationSuccess.middleName;
        memberObject.lastName = registrationSuccess.lastName;
        memberObject.emailAddress = registrationSuccess.emailAddress;
        memberObject.password = registrationSuccess.password;
        memberObject.confirmPassword = registrationSuccess.confirmPassword;
        memberObject.street1 = registrationSuccess.street1;
        memberObject.street2 = registrationSuccess.street2;
        memberObject.postalCode = registrationSuccess.postalCode;
        memberObject.city = registrationSuccess.city;
        memberObject.country = registrationSuccess.country;
        memberObject.purchasedProducts = registrationSuccess.purchasedProducts;
        memberObject.sessionId = registrationSuccess.sessionId;
        memberObject.customerId = registrationSuccess.customerId;
        memberObject.isMemberExist = registrationSuccess.isMemberExist;
        memberObject.membershipExpDate = registrationSuccess.membershipExpDate;
        memberObject.isMemberExpired = registrationSuccess.isMemberExpired;


        let today = new Date();
        this.router.navigate(['order']);
        
        // Start suggestion list
        /*
        if (memberObject.isMemberExist ===  true) {

          if (memberObject.purchasedProducts !== null) {

            if (memberObject.purchasedProducts.includes('OEMBLAV10')) {

              if (this.paymentLog.promoCode === 'medlemskap' ) {
                    this.router.navigate(['order']);
              }
              else {
                this.suggestionList.push({ 'code': 'medlemskap', 'price': '400'});
                this.sessionManager.setUserDataForRecommendation( this.suggestionList);
                this.router.navigate(['pathrecommendation']);
              }
            }
            else if (this.paymentLog.promoCode == 'versjon10ogmedlemskap') {

              // this.suggestionList.push({ 'code': 'versjon10', 'price': '900' });
              this.suggestionList.push({ 'code': 'versjon10ogmedlemskap', 'price': '1290' });
              this.router.navigate(['pathrecommendation']);
              this.sessionManager.setUserDataForRecommendation(this.suggestionList);
            }
            else {
                this.router.navigate(['order']);
            }
          }
          else {
            if (memberObject.isMemberExpired) {
              if (this.paymentLog.promoCode == 'medlemskap') {
                this.router.navigate(['order']);
              }
              else if (this.paymentLog.promoCode == 'versjon10') {
                this.suggestionList.push({ 'code': 'medlemskap', 'price': '400' });
                this.sessionManager.setUserDataForRecommendation(this.suggestionList);

                this.router.navigate(['pathrecommendation']);
              }
              else {
                this.suggestionList.push({ 'code': 'slektogdata', 'price': '990' });
                this.suggestionList.push({ 'code': 'historielag', 'price': '990' });
                this.suggestionList.push({ 'code': 'medlemskap', 'price': '400' });
                this.suggestionList.push({ 'code': 'versjon10ogmedlemskap', 'price': '1290' });

                this.sessionManager.setUserDataForRecommendation(this.suggestionList);

                this.router.navigate(['pathrecommendation']);
              }
            }
            else {
              this.router.navigate(['order']);
            }
          }
        }
        else {
          if (this.paymentLog.promoCode == 'versjon10') {
              // suggestion
            this.suggestionList.push({ 'code': 'slektogdata', 'price': '990' });
            this.suggestionList.push({ 'code': 'historielag', 'price': '990' });
            // this.suggestionList.push({ 'code': 'medlemskap', 'price': '400' });
            this.suggestionList.push({ 'code': 'versjon10ogmedlemskap', 'price': '1290' });

            this.sessionManager.setUserDataForRecommendation(this.suggestionList);
            this.router.navigate(['pathrecommendation']);
          }
          else if (this.paymentLog.promoCode == 'medlemskap') {
              // suggestion
            // this.suggestionList.push({ 'code': 'slektogdata', 'price': '990' });
            // this.suggestionList.push({ 'code': 'historielag', 'price': '990' });
            this.suggestionList.push({ 'code': 'versjon10ogmedlemskap', 'price': '1290' });

            this.sessionManager.setUserDataForRecommendation(this.suggestionList);
              this.router.navigate(['pathrecommendation']);
          }
          else {
            this.router.navigate(['order']);
          }
        }
          */
        // End suggestion list        
      },
        registrationFailed => {
          //debugger;
          // if (registrationFailed._body === '"WSSS556"') {
          //   this.router.navigate(['cannotregister']);
          // }
          // else {
          this.progress = false;
          this.errorMessage = 'Denne brukeren er allerede registrert, la oss gå tilbake til embla.no, klikk her';
          this.isSubmitting = false;
          this.log.errorCode = registrationFailed.text();
          this.router.navigate(['alert']);
          // }
        });
    // } else {
    //   this.visible = false;
    //   //this.router.navigate(['register']);
    // }
    //--------------------
  }

  updatePrivacyPolicy(state) {

    //add/update privacy policy
    if (state === 'Godta') {
      this.privacyPolicyStatus = 1;

      console.log("Here");
      this.register();
    }

  }

  showRegPage() {
    this.visible = true;
    this.isSubmitting = false;
    this.progress = false;
    this.errorMessage = '';
  }

  showPrivacyPage() {
    this.visible = false;
    this.errorMessage = '';
  }

  modelChanged(event) {
    if (this.errorMessage && !this.isSubmitting) {
      this.errorMessage = '';
      this.isSubmitting = false;
    }
  }

  emailValidate() {
    if (this.varEmailValidate) {
      this.varEmailValidate = false;
    } else {
      this.varEmailValidate = true;
    }
  }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/register/register.component.ts